import { render, staticRenderFns } from "./Caracteres.vue?vue&type=template&id=2bcc18ae&scoped=true"
import script from "./Caracteres.vue?vue&type=script&lang=js"
export * from "./Caracteres.vue?vue&type=script&lang=js"
import style0 from "./Caracteres.vue?vue&type=style&index=0&id=2bcc18ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc18ae",
  null
  
)

export default component.exports